import ReactDOM from 'react-dom';
import React from 'react';
import JumpableZoomableDragable from '../components/JumpableZoomableDragable';
import Urls from '../urls/Urls';
import ParameterErrors from '../errors/ParameterErrors';
import './FullScreenImagesViewer.css';
import IconButtonNonReact from './IconButtonNonReact';
const {throwNotProvided}=ParameterErrors;
export default class EmGalleryFullScreenImagesViewer {
	constructor(){
		this._galleryIframe = document.createElement('iframe');
		this._galleryIframe.classList.add('gallery');
		this._galleryIframe.allow="fullscreen";
		this._element = document.createElement('div');
		this._element.classList.add("full-screen-images-viewer");
		this.hide= this.hide.bind(this);
		this.show= this.show.bind(this);
		this._setVisible= this._setVisible.bind(this);
		this._handleClickButtonClose= this._handleClickButtonClose.bind(this);
		this._iconButtonNonReactClose = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Exit.png',
			onClick:this._handleClickButtonClose});
		this._element.appendChild(this._galleryIframe);
		this._element.appendChild(this._iconButtonNonReactClose.element);
	}
	_handleClickButtonClose(){
		this.hide();
	}
	get element(){
		return this._element;
	}
	hide(){
		this._setVisible(false);
	}
	show({src}){
		this._galleryIframe.src = src;
		this._setVisible(true);
	}
	_setVisible(value){
		if(value){
			document.body.classList.add('full-screen-images-viewer-visible');
			this._element.classList.add('visible');
		}
		else {
			document.body.classList.remove('full-screen-images-viewer-visible');
			this._element.classList.remove('visible');
		}
	}
}
